import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProjectProvider } from "@/context/ProjectContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppLayout from "@/components/AppLayout";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import ExecutiveDashboard from "@/pages/ExecutiveDashboard";
import ExecutiveProductivity from "@/pages/ExecutiveProductivity";
import Report from "@/pages/Report";
import DataEntry from "@/pages/DataEntry";
import WeeklyEntry from "@/pages/WeeklyEntry";
import ImportWizard from "@/pages/ImportWizard";
import Projects from "@/pages/Projects";
import RawProcoreData from "@/pages/RawProcoreData";
import ProcoreFieldMapping from "@/pages/ProcoreFieldMapping";
import Users from "@/pages/Users";
import Settings from "@/pages/Settings";

const Shell = ({ children, roles }) => (
  <ProtectedRoute roles={roles}>
    <ProjectProvider>
      <AppLayout>{children}</AppLayout>
    </ProjectProvider>
  </ProtectedRoute>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/" element={<Shell><Dashboard /></Shell>} />
            <Route path="/executive" element={<Shell roles={["admin"]}><ExecutiveDashboard /></Shell>} />
            <Route path="/executive-productivity" element={<Shell roles={["admin"]}><ExecutiveProductivity /></Shell>} />
            <Route path="/report" element={<Shell><Report /></Shell>} />
            <Route path="/data-entry" element={<Shell roles={["admin"]}><DataEntry /></Shell>} />
            <Route path="/weekly" element={<Shell roles={["admin"]}><WeeklyEntry /></Shell>} />
            <Route path="/imports" element={<Shell roles={["admin"]}><ImportWizard /></Shell>} />
            <Route path="/projects" element={<Shell roles={["admin"]}><Projects /></Shell>} />
            <Route path="/procore-data" element={<Shell roles={["admin"]}><RawProcoreData /></Shell>} />
            <Route path="/procore-mapping" element={<Shell roles={["admin"]}><ProcoreFieldMapping /></Shell>} />
            <Route path="/users" element={<Shell roles={["admin"]}><Users /></Shell>} />
            <Route path="/settings" element={<Shell roles={["admin"]}><Settings /></Shell>} />
          </Routes>
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
